import { render, staticRenderFns } from "./orderRight.vue?vue&type=template&id=5d031482&scoped=true"
import script from "./orderRight.vue?vue&type=script&lang=js"
export * from "./orderRight.vue?vue&type=script&lang=js"
import style0 from "./orderRight.vue?vue&type=style&index=0&id=5d031482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d031482",
  null
  
)

export default component.exports